import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import IWizardStep from '../../../../interfaces/IWizardStep';
import { WizardContent } from '../../components/WizardContent';
import { WizardTitle } from '../../components/WizardTitle';
import PeriodDate from './PeriodDate';
import PeriodTime from './PeriodTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import MoreTimeIcon from '@mui/icons-material/MoreTime';

interface PeriodProps extends IWizardStep {}

const Period = (props: PeriodProps) => {

 const getInitialTypeTime = () => {
    const role = props.medicalCertificate.typeDocument;
    const dayOnly = role?.launchInDay && !role?.launchInHours;
    const hourOnly = !role?.launchInDay && role?.launchInHours;

    if (dayOnly) return 'DAY';
    if (hourOnly) return 'HOUR';
    return props.medicalCertificate.typeTime;
  };

  const [typeTime, setTypeTime] = useState(getInitialTypeTime);
  const [launchDocumentRole] = useState(props.medicalCertificate.typeDocument);

  const bothFalse =
    !launchDocumentRole?.launchInDay && !launchDocumentRole?.launchInHours;

  const showDays = bothFalse || launchDocumentRole?.launchInDay;
  const showHours = bothFalse || launchDocumentRole?.launchInHours;

  const cardSx = (selected: boolean) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: 1,
    p: 2,
    borderRadius: 2,
    cursor: 'pointer',
    border: selected ? '2px solid rgb(32, 144, 136)' : '2px solid transparent',
    backgroundColor: selected ? 'rgba(32, 144, 136, 0.12)' : 'rgba(255,255,255,0.05)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: selected
        ? 'rgba(32, 144, 136, 0.18)'
        : 'rgba(255,255,255,0.1)',
    },
  });

  return (
    <WizardContent>
      <CalendarMonthIcon color="warning" fontSize="large" />
      <WizardTitle>Período do Atestado</WizardTitle> 
      <Typography variant="overline" sx={{ fontWeight: 500 }}>
        Qual o tempo do afastamento?
      </Typography> 
      
      <Box sx={{ display: 'flex', gap: 2, m:2 }}>
        {showDays && (
          <Box sx={cardSx(typeTime === 'DAY')} onClick={() => setTypeTime('DAY')}>
            <InsertInvitationIcon
              sx={{
                fontSize: 32,
                color: typeTime === 'DAY' ? 'rgb(32, 144, 136)' : 'grey.500',
              }}
            />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, letterSpacing: 1 }}>
              Dias
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'center', letterSpacing: 0.5 }}>
              Afastamento por dias completos
            </Typography>
          </Box>
        )}

        {showHours && (
          <Box sx={cardSx(typeTime === 'HOUR')} onClick={() => setTypeTime('HOUR')}>
            <MoreTimeIcon
              sx={{
                fontSize: 32,
                color: typeTime === 'HOUR' ? 'rgb(32, 144, 136)' : 'grey.500',
              }}
            />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, letterSpacing: 1 }}>
              Horas
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'center', letterSpacing: 0.5 }}>
              Afastamento parcial por horas
            </Typography>
          </Box>
        )}
      </Box>

      {typeTime === 'DAY' && showDays && <PeriodDate {...props} />}
      {typeTime === 'HOUR' && showHours && <PeriodTime {...props} />}
    </WizardContent>
  );
};

export default Period;